// test2706
(2706 && 0);
